(() => {
  if (window.ScrptdNativeCart) return;

  const drawer = document.querySelector('[data-scrptd-cart]');
  if (!drawer) return;

  const configNode = document.querySelector('[id^="ScrptdCartConfig-"]');
  let config;
  try {
    config = JSON.parse(configNode?.textContent || '{}');
  } catch (error) {
    console.error('SCRPTD cart configuration is invalid.', error);
    return;
  }

  const root = config.root || '/';
  const overlay = document.getElementById('cart-drawer-overlay');
  const itemsNode = drawer.querySelector('[data-scrptd-cart-items]');
  const emptyNode = drawer.querySelector('[data-scrptd-cart-empty]');
  const footerNode = drawer.querySelector('[data-scrptd-cart-footer]');
  const secondaryNode = drawer.querySelector('[data-scrptd-cart-secondary]');
  const totalNode = drawer.querySelector('[data-scrptd-cart-total]');
  const itemCountNode = drawer.querySelector('[data-scrptd-cart-item-count]');
  const dockStatusNode = drawer.querySelector('[data-scrptd-cart-dock-status]');
  const shippingNode = drawer.querySelector('[data-scrptd-shipping]');
  const shippingCopy = drawer.querySelector('[data-scrptd-shipping-copy]');
  const shippingTrack = drawer.querySelector('[data-scrptd-shipping-track]');
  const shippingProgress = drawer.querySelector('[data-scrptd-shipping-progress]');
  const goodChoice = drawer.querySelector('[data-scrptd-good-choice]');
  const upsellNode = drawer.querySelector('[data-scrptd-upsells]');
  const upsellCard = drawer.querySelector('[data-scrptd-upsell-card]');
  let lastTrigger = null;
  let currentCart = null;
  let upsellIndex = 0;
  let requestPending = false;
  let cartRequestId = 0;

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const money = (cents, currency = config.currency || 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')} €`;
    }
  };

  const imageUrl = (item) => item.featured_image?.url || item.image || '';
  const sizedImageUrl = (source, width) => source ? `${source}${source.includes('?') ? '&' : '?'}width=${width}` : '';
  const productUrl = (item) => item.url || `${root}products/${item.handle || ''}`;

  const updateCountBadges = (count) => {
    document.querySelectorAll('[data-cart-count], .cart-count, .scrptd-header-cart-count, .scrptd-cart-count').forEach((node) => {
      node.textContent = String(count);
      node.hidden = false;
    });
  };

  const itemMarkup = (item) => {
    const original = Number(item.original_line_price) || Number(item.final_line_price) || 0;
    const finalPrice = Number(item.final_line_price) || 0;
    const saving = Math.max(0, original - finalPrice);
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? `${config.sizeLabel || 'Größe'}: ${item.variant_title}`
      : '';
    const itemImage = imageUrl(item);
    return `
      <article class="scrptd-cart-item" data-cart-item-key="${escapeHtml(item.key)}">
        <a class="scrptd-cart-item__image-link" href="${escapeHtml(productUrl(item))}">
          ${itemImage ? `<img class="scrptd-cart-item__image" src="${escapeHtml(sizedImageUrl(itemImage, 220))}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
        </a>
        <div class="scrptd-cart-item__body">
          <a class="scrptd-cart-item__title" href="${escapeHtml(productUrl(item))}">${escapeHtml(item.product_title)}</a>
          ${variantTitle ? `<p class="scrptd-cart-item__variant">${escapeHtml(variantTitle)}</p>` : ''}
          <p class="scrptd-cart-item__prices">
            ${original > finalPrice ? `<span class="scrptd-cart-item__compare">${money(original, currentCart?.currency)}</span>` : ''}
            <strong>${money(finalPrice, currentCart?.currency)}</strong>
            ${saving ? `<span class="scrptd-cart-item__saving">(Spare ${money(saving, currentCart?.currency)})</span>` : ''}
          </p>
          <div class="scrptd-cart-item__quantity" aria-label="Menge">
            <button type="button" aria-label="Menge reduzieren" data-cart-quantity="${Math.max(0, item.quantity - 1)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" aria-label="Menge erhöhen" data-cart-quantity="${item.quantity + 1}">+</button>
          </div>
        </div>
        <button class="scrptd-cart-item__remove" type="button" aria-label="${escapeHtml(config.removeLabel || 'Entfernen')}" data-cart-quantity="0">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"/></svg>
        </button>
      </article>`;
  };

  const renderShipping = (cart) => {
    const goal = Number(config.shippingGoal) || 0;
    if (
      !shippingNode ||
      !shippingCopy ||
      !shippingTrack ||
      !shippingProgress ||
      !goal ||
      !cart.item_count
    ) {
      if (shippingNode) shippingNode.hidden = true;
      return;
    }
    const total = Number(cart.total_price) || 0;
    const giftEnabled = Boolean(config.giftEnabled);
    const configuredGiftGoal = Number(config.giftGoal) || 0;
    const giftGoal = giftEnabled ? Math.max(goal + 1, configuredGiftGoal) : goal;
    const remaining = Math.max(0, goal - total);
    const giftRemaining = Math.max(0, giftGoal - total);
    const percent = Math.min(100, Math.max(0, (total / giftGoal) * 100));
    const pending = String(config.shippingPending || '').replace('[amount]', money(remaining, cart.currency));
    const giftPending = String(config.giftPending || '').replace('[amount]', money(giftRemaining, cart.currency));
    if (remaining > 0) {
      shippingCopy.textContent = pending;
    } else if (giftEnabled && giftRemaining > 0) {
      shippingCopy.textContent = giftPending;
    } else if (giftEnabled) {
      shippingCopy.textContent = config.giftReached;
    } else {
      shippingCopy.textContent = config.shippingReached;
    }
    shippingProgress.style.setProperty('--scrptd-progress-remaining', `${100 - percent}%`);
    if (shippingTrack) shippingTrack.setAttribute('aria-valuenow', String(Math.round(percent)));
    if (shippingNode) {
      shippingNode.classList.toggle('is-shipping-reached', remaining === 0);
      shippingNode.classList.toggle('is-gift-active', giftEnabled && remaining === 0 && giftRemaining > 0);
      shippingNode.classList.toggle('is-gift-reached', giftEnabled && giftRemaining === 0);
      shippingNode.classList.toggle('is-reached', (!giftEnabled && remaining === 0) || (giftEnabled && giftRemaining === 0));
      shippingNode.hidden = false;
    }
  };

  const availableUpsells = (cart) => {
    const inCart = new Set((cart.items || []).map((item) => Number(item.product_id)));
    const seen = new Set();
    return (config.upsells || []).filter((product) => {
      const id = Number(product?.id);
      if (!id || seen.has(id) || inCart.has(id) || !product.variants?.some((variant) => variant.available)) {
        return false;
      }
      seen.add(id);
      return true;
    });
  };

  const renderUpsell = (cart) => {
    if (!upsellNode || !upsellCard) return;
    const products = availableUpsells(cart);
    if (!cart.item_count || !products.length) {
      upsellNode.hidden = true;
      upsellCard.replaceChildren();
      return;
    }
    upsellIndex = ((upsellIndex % products.length) + products.length) % products.length;
    const product = products[upsellIndex];
    const variants = product.variants || [];
    const availableVariants = variants.filter((variant) => variant.available);
    const selected = availableVariants[0];
    const compareAt = Number(selected?.compareAtPrice) || 0;
    const price = Number(selected?.price) || 0;
    const showSelect = variants.length > 1 || selected?.title !== 'Default Title';
    upsellCard.innerHTML = `
      <article class="scrptd-cart-upsell" data-upsell-product="${product.id}">
        <a class="scrptd-cart-upsell__image-link" href="${escapeHtml(product.url)}">
          ${product.image ? `<img class="scrptd-cart-upsell__image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
        </a>
        <div class="scrptd-cart-upsell__body">
          <a class="scrptd-cart-upsell__title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
          <div class="scrptd-cart-upsell__prices" data-upsell-prices>
            ${compareAt > price ? `<span class="scrptd-cart-upsell__compare">${money(compareAt, cart.currency)}</span>` : ''}
            <strong>${money(price, cart.currency)}</strong>
          </div>
          <div class="scrptd-cart-upsell__actions">
            ${showSelect ? `<select aria-label="${escapeHtml(config.sizeLabel || 'Größe')}" data-upsell-variant>
              ${variants.map((variant) => `<option value="${variant.id}" data-price="${variant.price}" data-compare="${variant.compareAtPrice || 0}" ${variant.available ? '' : 'disabled'}>${escapeHtml(variant.title)}${variant.available ? '' : ' – ausverkauft'}</option>`).join('')}
            </select>` : `<input type="hidden" value="${selected.id}" data-upsell-variant>`}
            <button type="button" data-upsell-add>${escapeHtml(config.addLabel || 'Hinzufügen')}</button>
          </div>
        </div>
      </article>`;
    upsellNode.hidden = false;
  };

  const render = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    currentCart = cart;
    const hasItems = Number(cart.item_count) > 0;
    if (itemsNode) itemsNode.innerHTML = hasItems ? cart.items.map(itemMarkup).join('') : '';
    if (emptyNode) emptyNode.hidden = hasItems;
    if (footerNode) footerNode.hidden = !hasItems;
    if (secondaryNode) secondaryNode.hidden = !hasItems;
    if (goodChoice) goodChoice.hidden = !hasItems;
    if (totalNode) totalNode.textContent = money(cart.total_price, cart.currency);
    if (itemCountNode) {
      const count = Number(cart.item_count) || 0;
      itemCountNode.textContent = `${count} ${count === 1 ? config.itemLabelSingular : config.itemLabelPlural}`;
    }
    if (dockStatusNode) {
      const total = Number(cart.total_price) || 0;
      const originalTotal = Number(cart.original_total_price) || total;
      const savings = Math.max(Number(cart.total_discount) || 0, originalTotal - total, 0);
      const shippingGoal = Number(config.shippingGoal) || 0;
      const remaining = Math.max(0, shippingGoal - total);
      if (savings > 0) {
        dockStatusNode.textContent = String(config.dockSaving || 'DU SPARST [amount]').replace('[amount]', money(savings, cart.currency));
      } else if (shippingGoal && remaining > 0) {
        dockStatusNode.textContent = String(config.dockShippingPending || '[amount] BIS KOSTENLOSEM VERSAND').replace('[amount]', money(remaining, cart.currency));
      } else if (shippingGoal) {
        dockStatusNode.textContent = config.dockShippingReached || 'KOSTENLOSER VERSAND';
      } else {
        dockStatusNode.textContent = '';
      }
    }
    renderShipping(cart);
    renderUpsell(cart);
    updateCountBadges(cart.item_count || 0);
  };

  const commitCart = (cart) => {
    cartRequestId += 1;
    render(cart);
    return cart;
  };

  const fetchCart = async () => {
    const requestId = ++cartRequestId;
    const response = await fetch(`${root}cart.js?_=${Date.now()}`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
    const cart = await response.json();
    if (requestId === cartRequestId) render(cart);
    return cart;
  };

  const reveal = (trigger) => {
    lastTrigger = trigger || document.activeElement;
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
    }
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scrptd-cart-open');
    drawer.querySelector('[data-scrptd-cart-close]')?.focus();
  };

  const openWithCart = (cart, trigger) => {
    reveal(trigger);
    drawer.classList.remove('is-loading');
    commitCart(cart);
  };

  const open = async (trigger) => {
    reveal(trigger);
    try {
      drawer.classList.add('is-loading');
      await fetchCart();
    } catch (error) {
      console.error(error);
    } finally {
      drawer.classList.remove('is-loading');
    }
  };

  const fetchConfirmedCart = async (expected = []) => {
    const expectedLines = (Array.isArray(expected) ? expected : [expected])
      .map((entry) => typeof entry === 'object'
        ? { id: Number(entry.id), quantity: Math.max(1, Number(entry.quantity) || 1) }
        : { id: Number(entry), quantity: 1 })
      .filter((entry) => entry.id);
    let lastCart = null;

    for (let attempt = 0; attempt < 5; attempt += 1) {
      if (attempt) {
        await new Promise((resolve) => window.setTimeout(resolve, 100 * attempt));
      }
      const response = await fetch(`${root}cart.js?_=${Date.now()}-${attempt}`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
      });
      if (!response.ok) continue;
      lastCart = await response.json();
      const confirmed = expectedLines.every((expectedLine) => (
        (lastCart.items || []).some((item) => (
          Number(item.variant_id) === expectedLine.id &&
          Number(item.quantity) >= expectedLine.quantity
        ))
      ));
      if (!expectedLines.length || confirmed) return lastCart;
    }

    if (lastCart) return lastCart;
    throw new Error('Der aktualisierte Warenkorb konnte nicht geladen werden.');
  };

  const close = () => {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-visible');
    document.body.classList.remove('scrptd-cart-open');
    window.setTimeout(() => {
      if (overlay) overlay.hidden = true;
    }, 250);
    lastTrigger?.focus?.();
  };

  const changeLine = async (key, quantity) => {
    if (requestPending) return;
    requestPending = true;
    drawer.classList.add('is-loading');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Menge konnte nicht aktualisiert werden.');
      commitCart(cart);
    } catch (error) {
      console.error(error);
      await fetchCart();
    } finally {
      requestPending = false;
      drawer.classList.remove('is-loading');
    }
  };

  const addUpsell = async (button) => {
    const card = button.closest('[data-upsell-product]');
    const selector = card?.querySelector('[data-upsell-variant]');
    const variantId = Number(selector?.value);
    if (!variantId || requestPending) return;
    requestPending = true;
    button.disabled = true;
    button.textContent = config.addingLabel || 'Wird hinzugefügt ...';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Produkt konnte nicht hinzugefügt werden.');
      await fetchCart();
    } catch (error) {
      console.error(error);
      button.textContent = config.addLabel || 'Hinzufügen';
      button.disabled = false;
    } finally {
      requestPending = false;
    }
  };

  drawer.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-scrptd-cart-close]');
    const quantityButton = event.target.closest('[data-cart-quantity]');
    const addButton = event.target.closest('[data-upsell-add]');
    if (closeButton) close();
    if (quantityButton) {
      const item = quantityButton.closest('[data-cart-item-key]');
      if (item) changeLine(item.dataset.cartItemKey, Number(quantityButton.dataset.cartQuantity));
    }
    if (addButton) addUpsell(addButton);
    if (event.target.closest('[data-scrptd-upsell-prev]')) {
      upsellIndex -= 1;
      renderUpsell(currentCart);
    }
    if (event.target.closest('[data-scrptd-upsell-next]')) {
      upsellIndex += 1;
      renderUpsell(currentCart);
    }
  });

  drawer.addEventListener('change', (event) => {
    const selector = event.target.closest('select[data-upsell-variant]');
    if (!selector) return;
    const option = selector.selectedOptions[0];
    const prices = selector.closest('.scrptd-cart-upsell__body')?.querySelector('[data-upsell-prices]');
    const price = Number(option?.dataset.price) || 0;
    const compareAt = Number(option?.dataset.compare) || 0;
    if (prices) prices.innerHTML = `${compareAt > price ? `<span class="scrptd-cart-upsell__compare">${money(compareAt, currentCart?.currency)}</span>` : ''}<strong>${money(price, currentCart?.currency)}</strong>`;
  });

  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('open')) close();
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let path;
    try { path = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, ''); } catch (_) { return; }
    const cartPath = `${root}cart`.replace(/\/+$/, '');
    if (path !== cartPath && !link.matches('[data-open-cart], .cart-text')) return;
    event.preventDefault();
    open(link);
  });

  ['scrptd:cart-change', 'cart:change', 'cart:updated', 'cart-updated', 'product-added', 'cart:refresh'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.detail?.items) commitCart(event.detail);
      else fetchCart().catch(console.error);
    });
  });

  window.openCartDrawer = open;
  window.openCartDrawerWithCart = openWithCart;
  window.closeCartDrawer = close;
  window.updateCart = fetchCart;
  window.ScrptdFetchConfirmedCart = fetchConfirmedCart;
  window.ScrptdNativeCart = {
    open,
    openWithCart,
    close,
    refresh: fetchCart,
    fetchConfirmedCart
  };
  fetchCart().catch(() => {});
})();
